<template>
  <div v-show="isActive" role="tabpanel" tabindex="0">
    <slot :is-active="isActive" />
  </div>
</template>

<script>
export default {
  props: {
    /**
     * Used to set the label of each tab (non unique)
     */
    label: {
      required: true,
      type: String
    },
    /**
     * Used to set the id of each tab to identify the tab (unique)
     */
    tabId: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      isActive: false
    }
  }
}
</script>
